import { render, staticRenderFns } from "./Pb.vue?vue&type=template&id=50044eaf&scoped=true"
import script from "./Pb.vue?vue&type=script&lang=js"
export * from "./Pb.vue?vue&type=script&lang=js"
import style0 from "./Pb.vue?vue&type=style&index=0&id=50044eaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50044eaf",
  null
  
)

export default component.exports